import {Button} from '@/components/ui/button';
import {Gift, Plus} from 'lucide-react';

interface EmptyStateProps {
    onCreate: () => void;
}

export const EmptyState = ({onCreate}: EmptyStateProps) => {
    return (
        <div className="rounded-lg bg-white p-12 shadow text-center">
            <div className="mx-auto h-16 w-16 text-gray-400 mb-4">
                <Gift className="h-16 w-16"/>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhum reward encontrado</h3>
            <p className="text-gray-600 mb-6">Crie seu primeiro reward para começar.</p>
            <Button
                onClick={onCreate}
                className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700"
            >
                <Plus className="mr-2 h-4 w-4"/>
                Criar Reward
            </Button>
        </div>
    );
};